import { VERSION } from "../constants";

const initialState = {
  stats: null,
  isLoadingGetVersions: false,
  error: null,
};

const versionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case VERSION.GET_VERSIONS:
      return { ...state, isLoadingGetVersions: true };
    case VERSION.GET_VERSIONS_FAILURE:
      return { ...state, isLoadingGetVersions: false, error: action.payload };
    case VERSION.GET_VERSIONS_SUCCESS:
      return {
        ...state,
        isLoadingGetVersions: false,
        stats: action.payload,
        error: null,
      };
    default:
      return state;
  }
};

export default versionReducer;
